// 只在正式建置註冊 service worker：開發模式（npm run serve）若註冊，
// 快取的建置檔會干擾熱更新。瀏覽器不支援或非 HTTPS（localhost 除外）時
// 瀏覽器本身會拒絕註冊，這裡只記錄不中斷。
export function registerServiceWorker() {
  if (process.env.NODE_ENV !== 'production') return;
  if (!('serviceWorker' in navigator)) return;

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register(`${process.env.BASE_URL}sw.js`)
      .catch((error) => console.warn('Service worker 註冊失敗：', error));
  });
}
